import React from 'react';
import { NavLink, Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Admin.css';

const AdminLayout: React.FC = () => {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (!user.is_admin) {
    return <Navigate to="/account" replace />;
  }

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h1>Admin Panel</h1>
        </div>
        <nav className="admin-nav">
          <NavLink
            to="/admin/users"
            className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}
          >
            Users
          </NavLink>
          <NavLink
            to="/admin/character-types"
            className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}
          >
            Character Types
          </NavLink>
          <NavLink
            to="/admin/enhancement-types"
            className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}
          >
            Enhancement Types
          </NavLink>
          <NavLink
            to="/admin/enhancement-tester"
            className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}
          >
            Enhancement Tester
          </NavLink>
          <NavLink
            to="/admin/categories"
            className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}
          >
            Categories
          </NavLink>
        </nav>
        <div className="admin-sidebar-footer">
          <NavLink to="/account" className="admin-nav-item">
            Back to Game
          </NavLink>
          <button onClick={logout} className="admin-logout-btn">
            Logout
          </button>
        </div>
      </aside>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
